import colors from "core/colors";

export const SHAPES = {
    SQUARE: "SQUARE",
    ROUNDED: "ROUNDED",
    CIRCLE: "CIRCLE",
    RING: "RING"
};

export const DEFAULT_CONTAINER_COLOR = colors.primary.diamond;
export const DEFAULT_SHAPE_COLOR = colors.secondary.chalice;
